// extracted by mini-css-extract-plugin
export default {"container":"ai-page_container__32Kwh","interactive":"ai-page_interactive__2aF8X"};